import DOMPurify from 'dompurify';

// Matches sanitize-html's default tag allowlist. DOMPurify's defaults are much
// broader (img, style, form, input, SVG, etc.) which we don't need.
const ALLOWED_TAGS = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
];

// Matches sanitize-html's default attribute allowlist:
// only href, name, target on <a> tags — nothing else.
const ALLOWED_ATTR = ['href', 'name', 'target'];

/**
 * Sanitize HTML using DOMPurify with a restrictive allowlist matching
 * sanitize-html's defaults. Strips img, style, form, input, SVG, script,
 * iframe, and most attributes (only href/name/target kept).
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS, ALLOWED_ATTR });
}
